// Browser composition root. Components retain the same subscription API.
import { staffSocketUrl } from '../components/api/staffSocket';
import BrowserLifecycle from './chat/BrowserLifecycle';
import createChatClient from './chat/createChatClient';
import SnapshotRefresher from './chat/SnapshotRefresher';
import { retryDelay } from './chat/protocol';
export { CHAT_CHANGES } from './chat/protocol';
export const browserScheduler = {
  set: (callback, delay) => setTimeout(callback, delay),
  clear: timer => clearTimeout(timer),
};
const client = createChatClient({
  socketFactory: url => new WebSocket(url),
  lifecycleFactory: pauseWhenHidden => new BrowserLifecycle(window, document, pauseWhenHidden),
  scheduler: browserScheduler,
  urlForPath: path => staffSocketUrl(path),
  random: () => Math.random(),
  onListenerError: () => console.warn('Chat update subscriber failed'),
});
export const subscribeChatEvents = (kind, token, listener) => client.subscribe(kind, token, listener);
export const eventRefresh = load => new SnapshotRefresher({ load, scheduler: browserScheduler, retryDelay });
